import React from 'react';

const Ads = () => {
  const partners = [
    {
      name: "The Mariner's Resort Boracay",
      description: "Official 5-Star Hotel Partner. Walk straight from the lobby to the beach. Secure your room before the regatta rush!",
      discount: "15% off with code: REGATTA26",
      img: "/mariners_resort_boracay.png"
    },
    {
      name: "Breeze Boutique Villas",
      description: "Luxury private villas perfect for entire sailing crews. Features private pools and gear lockers.",
      discount: "Book 3 nights, get 1 free",
      img: "https://images.unsplash.com/photo-1582719508461-905c673771fd?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      name: "Sailor's Hub Seaside Inn",
      description: "Affordable, comfortable, and right next to the yacht club. The perfect budget stay for quick weekends.",
      discount: "Affiliate Link: $50 / night",
      img: "https://images.unsplash.com/photo-1522798514-97ceb8c4f1c8?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    }
  ];

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h3 style={{ margin: 0 }}>📍 Local Accommodations & Sponsors</h3>
        <span style={{ fontSize: '12px', color: '#999', border: '1px solid #ddd', padding: '2px 8px', borderRadius: '10px' }}>Advertisement</span>
      </div>
      
      <p style={{ color: '#555', marginBottom: '25px' }}>
        Support the regatta by booking your stay through our official partners. (Booking through these links helps keep the tournament free to enter!)
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '20px' }}>
        {partners.map((partner, index) => (
          <div key={index} style={{
            border: '1px solid #eee', borderRadius: '8px', overflow: 'hidden',
            display: 'flex', flexDirection: 'column', backgroundColor: '#fff',
            boxShadow: '0 4px 6px rgba(0,0,0,0.05)', transition: 'transform 0.2s'
          }}>
            <div style={{ height: '180px', width: '100%' }}>
              <img 
                src={partner.img} 
                alt={partner.name}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
            <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
              <h4 style={{ margin: '0 0 10px 0', fontSize: '18px', color: '#2c3e50' }}>{partner.name}</h4>
              <p style={{ margin: '0 0 15px 0', fontSize: '14px', color: '#666', lineHeight: '1.5' }}>
                {partner.description}
              </p>
              <div style={{ marginTop: 'auto' }}>
                <p style={{ margin: '0 0 15px 0', fontSize: '13px', color: '#28a745', fontWeight: 'bold' }}>
                  🎁 {partner.discount}
                </p>
                <button 
                  style={{ width: '100%', backgroundColor: '#0056b3', color: 'white', border: 'none', padding: '12px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
                  onClick={() => alert(`Redirecting to affiliate booking page for ${partner.name}...`)}
                >
                  Check Availability & Book
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Ads;
